import _ from 'lodash';
import {
    FETCH_ESAT_PRODUCTS,
    CLEAN_ESAT_PRODUCTS,
    DELETE_ESAT_PRODUCT,
    DELETE_ESAT_PRODUCTS,
    PREPARE_ESAT_PRODUCT,
    SEND_ESAT_PRODUCT,
    SEND_ESAT_PRODUCTS,
    REMOVE_ESAT_PRODUCT,
} from './types';
import {request, __} from '../functions';

export const fetchEsatProducts = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/esat/products', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_ESAT_PRODUCTS, payload: data });
    });
};

export const cleanEsatProducts = () => ({ type: CLEAN_ESAT_PRODUCTS });

export const deleteEsatProduct = (screen, id) => {
    return dispatch => request(`/esat/removeProduct/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Objednavku sa nepodarilo zmazat
            screen.showSnackbar('error', __('Produkt sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Produkt bol zmazaný'));

        dispatch({ type: DELETE_ESAT_PRODUCT });
    });
};

export const deleteEsatProducts = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/esat/multiDeleteProducts/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať produkty'));
            return;
        }

        screen.showSnackbar('success', __('Produkty boli zmazané'));

        dispatch({ type: DELETE_ESAT_PRODUCTS });
    });
};

export const prepareEsatProduct = (screen, id) => {
    return dispatch => request(`/esat/setProductPrepare/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Produkt sa nepodarilo zmeniť'));
            return;
        }

        screen.showSnackbar('success', __('Produkt bol upravený'));

        dispatch({ type: PREPARE_ESAT_PRODUCT, payload: { id } });
    });
};

export const sendEsatProduct = (screen, id, user_eshop_id) => {
    return dispatch => request(`/esat/sendProduct/${user_eshop_id}/${id}`).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Produkt sa nepodarilo odoslať'));
        } else {
            screen.showSnackbar('success', __('Produkt bol odoslaný'));
        }

        dispatch({ type: SEND_ESAT_PRODUCT, payload: { id, user_eshop_id, status, data } });
    });
};

export const sendEsatProducts = (screen, ids, user_eshop_id, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/esat/sendProducts/${user_eshop_id}/${ids}`, params).then(response => {
        const { status, data } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa odoslať produkty'));
            return;
        }

        if (_.isEmpty(data.errors)) {
            screen.showSnackbar('success', __('Produkty boli odoslané'));
        } else if (_.isEmpty(data.reference_ids)) {
            screen.showSnackbar('error', __('Nepodarilo sa odoslať produkty'));
        } else {
            screen.showSnackbar('error', __('Počet neodoslaných produktov: {COUNT}, ostatné boli odoslané.').replace('{COUNT}', _.keys(data.errors).length));
        }

        dispatch({ type: SEND_ESAT_PRODUCTS, payload: { user_eshop_id, data } });
    });
};

export const removeEsatProduct = (screen, id, user_eshop_id) => {
    return dispatch => request(`/esat/deleteProduct/${user_eshop_id}/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Produkt sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Produkt bol zmazaný'));

        dispatch({ type: REMOVE_ESAT_PRODUCT, payload: { id, user_eshop_id } });
    });
};
